var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JbPlanNew',{attrs:{"biz-ctg":_vm.$config.BIZ_CATEGORY.PATROL},on:{"link":_vm.linkToList}})
}
var staticRenderFns = []

export { render, staticRenderFns }